export const TOKEN_KEYS = {
	ACCESS_TOKEN: "access_token",
	REFRESH_TOKEN: "refreshToken",
	EXPIRES_IN: "expiresIn",
	EXPIRES_AT: "expiresAt",
};
